<template>
  <b-row>
    <b-col cols="12">
      <form-wizard-edit />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormWizardEdit from './FormWizardEdit.vue'

export default {
  components: {
    BRow,
    BCol,
    FormWizardEdit,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
